export const BILLING_PAYMENTS = 'BILLING_PAYMENTS';
export const HSD_REPAIR = 'HSD_REPAIR';
export const VID_REPAIR = 'VID_REPAIR';
export const UNKNOWN = 'UNKNOWN';
